module.exports = __webpack_public_path__ + "static/media/onboarding-gameoverview-image3.4e9ae505.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/onboarding-gameoverview-image3.png
// module id = 2706
// module chunks = 0